'use client';
import { ZIndexElevations } from './domain.js';

var getDefaultZIndex = function(level) {
    return ZIndexElevations[level];
};

export { getDefaultZIndex };
